module.exports = __webpack_public_path__ + "static/media/1. Atardecer. Óleo y acrilico. 100 x 200 cm. 2021 copy.b7f7cdcc.png";